<template>
  <div :class="$style.root" />
</template>

<script>
import { number } from 'vue-types';

export default {
  props: {
    value: number().isRequired,
  },

  computed: {
    width() {
      return `${this.value}%`;
    },
  },
};
</script>

<style lang="scss" module>
.root {
  position: relative;
  height: 8px;
  border-radius: 10px;
  background: rgba(151, 174, 225, 0.2);
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    border-radius: 10px 0 0 10px;
    background-color: #1A88F3;
    width: v-bind(width);
  }
}
</style>
